import { doClearValuesWithIds } from '@databases/redux/contextual-menu/actions';
import { appStore } from '@databases/redux/store';
import { createClearCellsEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export function createClearCellsEffectFeature(deps: {
  contentId: string;
}): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.CLEAR_CELLS_EFFECT,
    type: 'effect',
    isEnabled: (perms) => perms.canEditContent,
    factory: () => {
      const selectionsApi = getService('SelectionsApi');

      return createClearCellsEffect({
        resolveRangeToIds: (r) => selectionsApi.resolveRangeToIds(r),
        onClearValues: (entryIds: string[], fieldIds: string[]) => {
          appStore.dispatch(doClearValuesWithIds(deps.contentId, entryIds, fieldIds));
        },
      });
    },
  };
}
